var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#707070;}.b{fill:#6e7191;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 16,
    cy: 15.5,
    rx: 16,
    ry: 15.5,
    transform: "translate(1211.281 4531.281)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1162 -4367)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1162 4367)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-47.281 -164.281)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.076,5.73c.9-1.675-.129-3.866-.129-3.866A6.465,6.465,0,0,0,17.953,3.41c-.9-.515-3.866-.515-3.866-.515s-2.964,0-3.866.515A6.465,6.465,0,0,0,6.226,1.864S5.195,4.054,6.1,5.73c0,0-2.062,1.933-1.289,6.057.727,3.875,4.124,4.9,6.314,4.9a2.524,2.524,0,0,0-.773,2.062A3.2,3.2,0,0,1,7.772,19a4.136,4.136,0,0,1-1.933-1.8s-1.289-1.675-2.577-1.031c0,0-.387.387,1.031,1.031A21.236,21.236,0,0,1,5.71,19.647c.387.9,2.448,1.675,4.51,1.16v2.964s0,.258-.515.387-.515.387-.258.387h9.278c.258,0,.258-.258-.258-.387s-.515-.387-.515-.387V20.807s.011-1.546,0-2.062a3.005,3.005,0,0,0-.9-2.062c2.191,0,5.588-1.022,6.314-4.9C24.138,7.663,22.076,5.73,22.076,5.73Z",
    transform: "translate(1213.905 4537.737)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithub);
export default __webpack_public_path__ + "static/media/icon_github.229bb4045a5d663f0b7d82433cc4b3c1.svg";
export { ForwardRef as ReactComponent };